// Prima di tutto: le chiavi del browser di quando il prodotto si chiamava ADABS.
import './migraChiavi'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import App from './App'
import './styles.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
